export const pathnameFromUrl = (url?: string) => {
    if (!url) return undefined;

    try {
        return new URL(url).pathname;
    } catch {
        return undefined;
    }
};
